"use client";

import { useEffect, useRef } from "react";
import { usePathname, useSearchParams } from "next/navigation";

import { captureAttributionCookiesFromBrowser } from "@/lib/attribution-cookies";

export function AttributionCookieCapture() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const searchString = searchParams.toString();
  const shouldCaptureDocumentReferrer = useRef(true);

  useEffect(() => {
    captureAttributionCookiesFromBrowser({
      pathname,
      searchParams: new URLSearchParams(searchString),
      referrer: shouldCaptureDocumentReferrer.current ? document.referrer : null,
    });
    shouldCaptureDocumentReferrer.current = false;
  }, [pathname, searchString]);

  return null;
}
